var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","background-color":"#FFF","padding":"20px 0"}},[_c('ele-chart',{staticStyle:{"height":"600px","width":"100%"},attrs:{"option":_vm.visitHourChartOption}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }